import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { Rewards } from '@core/models/rewards.model';
import { SKIP_ERROR_INTERCEPTOR_HEADER } from '@utils/constants';

@Injectable()
export class RewardsDataService extends DefaultDataService<Rewards> {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('Reward', http, httpUrlGenerator, { root: '' });
  }

  getById(id: number): Observable<Rewards>{
    return this.http.get<ApiResponse>(`/reward/${id}`).pipe(
      map(res => res.data.rows)
    );
  }

  updateReward(data: Rewards): Observable<Rewards>{
    return this.http.put<ApiResponse>(`/reward/${data.id}`, data).pipe(
      tap( res => this.messages$.next(res.message)),
      map((row: ApiResponse) => row.data.rows)
    );
  }

  import(data: FormData) {
    // Bypass the global interceptor so the dialog can show its own message
    // (the interceptor silently swallows 409s — reserved for the registration
    // identical-settings flow — which would otherwise hide the duplicate-import
    // warning).
    const headers = new HttpHeaders().set(SKIP_ERROR_INTERCEPTOR_HEADER, 'true');
    return this.http.post<ApiResponse>(`/reward/import`, data, { headers }).pipe(
      tap(res => this.messages$.next(res.message)),
      map((res) => res.data)
    );
  }

  getImport(id: number) {
    return this.http.get<ApiResponse>(`/imports/${id}`).pipe(
      map(res => res.data)
    );
  }

  checkEligibility(promotion_id: number, member_id: number, is_reward: number) {
    return this.http.get<ApiResponse>(`/promotion/checkeligibility?promotion_id=${promotion_id}&member_account_id=${member_id}&is_reward=${is_reward}`).pipe(
      map(res => res)
    );
  }

}
